import { mapState } from 'vuex';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import { redirectToAppWithError } from '@/utils/appLoginHelper';

// @vue/component
export default {
  name: 'SiteNotFound',
  components: {
    PageHeader,
  },
  data() {
    return {
      siteAddress: window.location.hostname,
    };
  },
  computed: {
    ...mapState({
      inAppLogin: (state) => state.login.loginType === 'app',
      appInfo: (state) => state.login.appInfo,
    }),
  },
  methods: {
    onClickBackToApp() {
      redirectToAppWithError(
        this.appInfo,
        'server_error',
        'users installation could not be found',
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/sections/SiteNotFound/SiteNotFound.js